import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import IndexRepository from '../Repositories/IndexRepository'

class IndexBloc {

    rowtableChannel = new Subject();
    inactiveChannel = new Subject();
    detailInactiveChannel = new Subject();
    listPegawaiChannel = new Subject();
    listJabatanChannel = new Subject();
    listUnitKerjaChannel = new Subject();
    detailChannel = new Subject();
    repository = new IndexRepository()

    constructor() {
        this.rowtableChannel.next({status: apiResponse.INITIAL})
        this.inactiveChannel.next({status: apiResponse.INITIAL})
        this.detailInactiveChannel.next({status: apiResponse.INITIAL})
        this.listPegawaiChannel.next({status: apiResponse.INITIAL})
        this.listJabatanChannel.next({status: apiResponse.INITIAL})
        this.listUnitKerjaChannel.next({status: apiResponse.INITIAL})
        this.detailChannel.next({status: apiResponse.INITIAL})
    }

    fetchRowTable = async (query, cancelToken) => {
        try {
            this.rowtableChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchRowTable(query, cancelToken).then((result) => {
                this.rowtableChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.rowtableChannel.next({status: apiResponse.ERROR, data: error})
            })           
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    fetchInactive = async (query) => {
        try {
            this.inactiveChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchInactive(query).then((result) => {
                this.inactiveChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.inactiveChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }

    fetchDetailInactive = async (query) => {
        try {
            this.detailInactiveChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchDetailInactive(query).then((result) => {
                this.detailInactiveChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.detailInactiveChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Error fetching')
        }
    }

    fetchListPegawai = async (query) => {
        try {
            this.listPegawaiChannel.next({ status: apiResponse.LOADING })
            await this.repository.fetchListPegawai(query).then((result) => {
                this.listPegawaiChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.listPegawaiChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Error fetching')
        }
    }

    fetchListJabatan = async (query) => {
        try {
            this.listJabatanChannel.next({  status: apiResponse.LOADING })
            await this.repository.fetchListJabatan(query).then((result) => {
                this.listJabatanChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.listJabatanChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Error fetching')
        }
    }

    fetchListUnitKerja = async (query) => {
        try {
            this.listUnitKerjaChannel.next({ status: apiResponse.LOADING })
            await this.repository.fetchListUnitKerja(query).then((result) => {
                this.listUnitKerjaChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.listUnitKerjaChannel.next({ status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Error fetching')
        }
    }

    fetchDetail = async (query) => {
        try {
            this.detailChannel.next({ status: apiResponse.LOADING })
            await this.repository.fetchDetail(query).then((result) => {
                this.detailChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.detailChannel.next({ status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Error fetching')
        }
    }

}

export default IndexBloc